/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SummaryBankAccountResponse } from './SummaryBankAccountResponse';
import {
    SummaryBankAccountResponseFromJSON,
    SummaryBankAccountResponseFromJSONTyped,
    SummaryBankAccountResponseToJSON,
    SummaryBankAccountResponseToJSONTyped,
} from './SummaryBankAccountResponse';
import type { SummaryChannelResponse } from './SummaryChannelResponse';
import {
    SummaryChannelResponseFromJSON,
    SummaryChannelResponseFromJSONTyped,
    SummaryChannelResponseToJSON,
    SummaryChannelResponseToJSONTyped,
} from './SummaryChannelResponse';

/**
 * 
 * @export
 * @interface SummaryRevenuesResponse
 */
export interface SummaryRevenuesResponse {
    /**
     * 
     * @type {Array<SummaryChannelResponse>}
     * @memberof SummaryRevenuesResponse
     */
    immediatePayment?: Array<SummaryChannelResponse>;
    /**
     * 
     * @type {Array<SummaryBankAccountResponse>}
     * @memberof SummaryRevenuesResponse
     */
    bankAccounts?: Array<SummaryBankAccountResponse>;
    /**
     * 
     * @type {Array<SummaryChannelResponse>}
     * @memberof SummaryRevenuesResponse
     */
    cash?: Array<SummaryChannelResponse>;
}

/**
 * Check if a given object implements the SummaryRevenuesResponse interface.
 */
export function instanceOfSummaryRevenuesResponse(value: object): value is SummaryRevenuesResponse {
    return true;
}

export function SummaryRevenuesResponseFromJSON(json: any): SummaryRevenuesResponse {
    return SummaryRevenuesResponseFromJSONTyped(json, false);
}

export function SummaryRevenuesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SummaryRevenuesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'immediatePayment': json['immediatePayment'] == null ? undefined : ((json['immediatePayment'] as Array<any>).map(SummaryChannelResponseFromJSON)),
        'bankAccounts': json['bankAccounts'] == null ? undefined : ((json['bankAccounts'] as Array<any>).map(SummaryBankAccountResponseFromJSON)),
        'cash': json['cash'] == null ? undefined : ((json['cash'] as Array<any>).map(SummaryChannelResponseFromJSON)),
    };
}

export function SummaryRevenuesResponseToJSON(json: any): SummaryRevenuesResponse {
    return SummaryRevenuesResponseToJSONTyped(json, false);
}

export function SummaryRevenuesResponseToJSONTyped(value?: SummaryRevenuesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'immediatePayment': value['immediatePayment'] == null ? undefined : ((value['immediatePayment'] as Array<any>).map(SummaryChannelResponseToJSON)),
        'bankAccounts': value['bankAccounts'] == null ? undefined : ((value['bankAccounts'] as Array<any>).map(SummaryBankAccountResponseToJSON)),
        'cash': value['cash'] == null ? undefined : ((value['cash'] as Array<any>).map(SummaryChannelResponseToJSON)),
    };
}

